// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExcludePathsManager_wrap_path_settings__nDxX7 {
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  transition: border-color 0.2s ease;
}

.ExcludePathsManager_controlGroup__Nf9KW {
  margin-bottom: 30px;
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}

.ExcludePathsManager_controlLabel__IWAyz {
  display: flex;
  cursor: pointer;
  flex-direction: column-reverse;
}

.ExcludePathsManager_labelText__zFzy2 {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  display: block;
  margin-bottom: 10px;
}

.ExcludePathsManager_toggleContainer__gL2W\\+ {
  display: flex;
  align-items: center;
  gap: 12px;
  /* margin-bottom: 8px; */
  justify-content: flex-end;
}

.ExcludePathsManager_toggleLabel__iee\\+8 {
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  /* min-width: 70px; */
}

.ExcludePathsManager_toggleSwitch__G026p {
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.ExcludePathsManager_toggleOn__\\+LzwM {
  background-color: var(--saveBtn);
}

.ExcludePathsManager_toggleOff__q0EOL {
  background-color: #ccc;
}

.ExcludePathsManager_toggleSlider__CIIQh {
  width: 20px;
  height: 20px;
  background-color: var(--white-color);
  border-radius: 50%;
  position: absolute;
  top: 2px;
  transition: transform 0.3s;
}

.ExcludePathsManager_toggleOn__\\+LzwM .ExcludePathsManager_toggleSlider__CIIQh {
  transform: translateX(26px);
}

.ExcludePathsManager_toggleOff__q0EOL .ExcludePathsManager_toggleSlider__CIIQh {
  transform: translateX(2px);
}

.ExcludePathsManager_helperText__RJ7Ze {
  font-size: 13px;
  color: #6c757d;
  margin: 5px 0 0 0;
  font-style: italic;
}

.ExcludePathsManager_pathsSection__VJXG- {
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}

.ExcludePathsManager_sectionTitle__P6N0t {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin: 0 0 5px 0;
}

.ExcludePathsManager_sectionDescription__EyDDl {
  font-size: 14px;
  color: #6c757d;
  margin: 0 0 20px 0;
}

.ExcludePathsManager_inputGroup__P7QJ4 {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.ExcludePathsManager_pathInput__nCfsR {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.ExcludePathsManager_pathInput__nCfsR:focus {
  outline: none;
  border-color: #a3bdff;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
}

.ExcludePathsManager_addButton__gI31x {
  padding: 10px 20px;
  background-color: var(--saveBtn);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ExcludePathsManager_addButton__gI31x:hover:not(:disabled) {
  background-color: var(--saveHover);
}

.ExcludePathsManager_addButton__gI31x:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.ExcludePathsManager_pathsList__wDjtO {
  margin-top: 15px;
}

.ExcludePathsManager_listTitle__0zSjt {
  font-size: 15px;
  font-weight: 600;
  color: #495057;
  margin: 0 0 10px 0;
}

.ExcludePathsManager_pathItems__3WQKZ {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ExcludePathsManager_pathItem__bN6GT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.2s;
}

.ExcludePathsManager_pathItem__bN6GT:hover {
  border-color: var(--deleteHover);
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);
}

.ExcludePathsManager_pathText__rMoPR {
  font-family: monospace;
  font-size: 14px;
  color: #495057;
}

.ExcludePathsManager_removeButton__TAiF5 {
  background: none;
  border: none;
  color: var(--deleteBtn);
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.ExcludePathsManager_removeButton__TAiF5:hover {
  background-color: #dc3545;
  color: white;
}

.ExcludePathsManager_emptyState__JM2Ak {
  text-align: center;
  padding: 20px;
  background: white;
  border: 1px dashed #ced4da;
  border-radius: 4px;
  color: #6c757d;
  font-style: italic;
}

.ExcludePathsManager_helperBox__iDHku {
  margin-top: 20px;
  padding: 15px;
  background: #d1deeb;
  border-radius: 4px;
  border-left: 4px solid #2196f3;
}

.ExcludePathsManager_helperBoxTitle__3V3Mp {
  font-size: 14px;
  font-weight: 600;
  color: #0d47a1;
  margin: 0 0 8px 0;
}

.ExcludePathsManager_helperBoxList__95tzu {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #1565c0;
}

.ExcludePathsManager_helperBoxList__95tzu li {
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/GeneralAppSettings/ExcludePathsManager/ExcludePathsManager.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".wrap_path_settings {\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  transition: border-color 0.2s ease;\n}\n\n.controlGroup {\n  margin-bottom: 30px;\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n\n.controlLabel {\n  display: flex;\n  cursor: pointer;\n  flex-direction: column-reverse;\n}\n\n.labelText {\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.toggleContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  /* margin-bottom: 8px; */\n  justify-content: flex-end;\n}\n\n.toggleLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #6c757d;\n  /* min-width: 70px; */\n}\n\n.toggleSwitch {\n  width: 50px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.toggleOn {\n  background-color: var(--saveBtn);\n}\n\n.toggleOff {\n  background-color: #ccc;\n}\n\n.toggleSlider {\n  width: 20px;\n  height: 20px;\n  background-color: var(--white-color);\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  transition: transform 0.3s;\n}\n\n.toggleOn .toggleSlider {\n  transform: translateX(26px);\n}\n\n.toggleOff .toggleSlider {\n  transform: translateX(2px);\n}\n\n.helperText {\n  font-size: 13px;\n  color: #6c757d;\n  margin: 5px 0 0 0;\n  font-style: italic;\n}\n\n.pathsSection {\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #495057;\n  margin: 0 0 5px 0;\n}\n\n.sectionDescription {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0 0 20px 0;\n}\n\n.inputGroup {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.pathInput {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.pathInput:focus {\n  outline: none;\n  border-color: #a3bdff;\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);\n}\n\n.addButton {\n  padding: 10px 20px;\n  background-color: var(--saveBtn);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.addButton:hover:not(:disabled) {\n  background-color: var(--saveHover);\n}\n\n.addButton:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.pathsList {\n  margin-top: 15px;\n}\n\n.listTitle {\n  font-size: 15px;\n  font-weight: 600;\n  color: #495057;\n  margin: 0 0 10px 0;\n}\n\n.pathItems {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.pathItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  transition: all 0.2s;\n}\n\n.pathItem:hover {\n  border-color: var(--deleteHover);\n  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.1);\n}\n\n.pathText {\n  font-family: monospace;\n  font-size: 14px;\n  color: #495057;\n}\n\n.removeButton {\n  background: none;\n  border: none;\n  color: var(--deleteBtn);\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.removeButton:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 20px;\n  background: white;\n  border: 1px dashed #ced4da;\n  border-radius: 4px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.helperBox {\n  margin-top: 20px;\n  padding: 15px;\n  background: #d1deeb;\n  border-radius: 4px;\n  border-left: 4px solid #2196f3;\n}\n\n.helperBoxTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0d47a1;\n  margin: 0 0 8px 0;\n}\n\n.helperBoxList {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 13px;\n  color: #1565c0;\n}\n\n.helperBoxList li {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap_path_settings": `ExcludePathsManager_wrap_path_settings__nDxX7`,
	"controlGroup": `ExcludePathsManager_controlGroup__Nf9KW`,
	"controlLabel": `ExcludePathsManager_controlLabel__IWAyz`,
	"labelText": `ExcludePathsManager_labelText__zFzy2`,
	"toggleContainer": `ExcludePathsManager_toggleContainer__gL2W+`,
	"toggleLabel": `ExcludePathsManager_toggleLabel__iee+8`,
	"toggleSwitch": `ExcludePathsManager_toggleSwitch__G026p`,
	"toggleOn": `ExcludePathsManager_toggleOn__+LzwM`,
	"toggleOff": `ExcludePathsManager_toggleOff__q0EOL`,
	"toggleSlider": `ExcludePathsManager_toggleSlider__CIIQh`,
	"helperText": `ExcludePathsManager_helperText__RJ7Ze`,
	"pathsSection": `ExcludePathsManager_pathsSection__VJXG-`,
	"sectionTitle": `ExcludePathsManager_sectionTitle__P6N0t`,
	"sectionDescription": `ExcludePathsManager_sectionDescription__EyDDl`,
	"inputGroup": `ExcludePathsManager_inputGroup__P7QJ4`,
	"pathInput": `ExcludePathsManager_pathInput__nCfsR`,
	"addButton": `ExcludePathsManager_addButton__gI31x`,
	"pathsList": `ExcludePathsManager_pathsList__wDjtO`,
	"listTitle": `ExcludePathsManager_listTitle__0zSjt`,
	"pathItems": `ExcludePathsManager_pathItems__3WQKZ`,
	"pathItem": `ExcludePathsManager_pathItem__bN6GT`,
	"pathText": `ExcludePathsManager_pathText__rMoPR`,
	"removeButton": `ExcludePathsManager_removeButton__TAiF5`,
	"emptyState": `ExcludePathsManager_emptyState__JM2Ak`,
	"helperBox": `ExcludePathsManager_helperBox__iDHku`,
	"helperBoxTitle": `ExcludePathsManager_helperBoxTitle__3V3Mp`,
	"helperBoxList": `ExcludePathsManager_helperBoxList__95tzu`
};
export default ___CSS_LOADER_EXPORT___;
